import { Pipe, PipeTransform } from '@angular/core';

/** Solo dígitos; conserva + inicial si venía. */
export function cleanPhone(value: string | number | null | undefined): string {
  if (value == null || value === '') return '';
  const s = String(value).trim();
  if (!s) return '';
  const hasPlus = s.startsWith('+');
  const digits = s.replace(/\D/g, '');
  if (!digits) return '';
  return hasPlus ? `+${digits}` : digits;
}

/**
 * Formato visual aproximado Chile:
 * +56912345678 → +56 9 1234 5678
 * 912345678 → 9 1234 5678
 */
export function formatPhone(value: string | number | null | undefined): string {
  const raw = cleanPhone(value);
  if (!raw) return '';

  const plus = raw.startsWith('+');
  let digits = plus ? raw.slice(1) : raw;

  // +56 9 XXXX XXXX
  if (plus && digits.startsWith('56') && digits.length >= 11) {
    const rest = digits.slice(2);
    if (rest.length === 9) {
      return `+56 ${rest[0]} ${rest.slice(1, 5)} ${rest.slice(5)}`;
    }
    return `+56 ${rest}`;
  }

  // 9 XXXX XXXX (móvil local)
  if (!plus && digits.length === 9 && digits.startsWith('9')) {
    return `${digits[0]} ${digits.slice(1, 5)} ${digits.slice(5)}`;
  }

  // fallback: grupos de 4 desde el final
  const parts: string[] = [];
  while (digits.length > 4) {
    parts.unshift(digits.slice(-4));
    digits = digits.slice(0, -4);
  }
  if (digits) parts.unshift(digits);
  return (plus ? '+' : '') + parts.join(' ');
}

@Pipe({
  name: 'phoneFormat',
  standalone: true,
})
export class PhoneFormatPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    return formatPhone(value);
  }
}
